[
  {
    "songId": 0,
    "intensity": 0,
    "entryIds": [
      300,
      302,
      304,
      306,
      308,
      310,
      312
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 2,
        "tables": [
          "a",
          "b"
        ]
      },
      {
        "level": 4,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 73.88,
    "source": "esoteria-exe"
  },
  {
    "songId": 0,
    "intensity": 1,
    "entryIds": [
      314,
      316,
      318,
      320,
      322,
      324,
      326
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 2,
        "tables": [
          "a",
          "b"
        ]
      },
      {
        "level": 4,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 80.43,
    "source": "esoteria-exe"
  },
  {
    "songId": 0,
    "intensity": 2,
    "entryIds": [
      328,
      330,
      332,
      334,
      336,
      338,
      340
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 2,
        "tables": [
          "a",
          "b"
        ]
      },
      {
        "level": 4,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 61.077,
    "source": "esoteria-exe"
  },
  {
    "songId": 1,
    "intensity": 0,
    "entryIds": [
      342,
      344,
      346,
      348,
      350,
      352,
      354
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 4,
        "tables": [
          "a"
        ]
      },
      {
        "level": 5,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 69.943,
    "source": "esoteria-exe"
  },
  {
    "songId": 1,
    "intensity": 1,
    "entryIds": [
      356,
      358,
      360,
      362,
      364,
      366,
      368
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 4,
        "tables": [
          "a"
        ]
      },
      {
        "level": 5,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 70.254,
    "source": "esoteria-exe"
  },
  {
    "songId": 1,
    "intensity": 2,
    "entryIds": [
      370,
      372,
      374,
      376,
      378,
      380,
      382
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 4,
        "tables": [
          "a"
        ]
      },
      {
        "level": 5,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 76.382,
    "source": "esoteria-exe"
  },
  {
    "songId": 2,
    "intensity": 0,
    "entryIds": [
      384,
      386,
      388,
      390,
      392,
      394,
      396
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 3,
        "tables": [
          "a"
        ]
      },
      {
        "level": 7,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 61.968,
    "source": "esoteria-exe"
  },
  {
    "songId": 2,
    "intensity": 1,
    "entryIds": [
      398,
      400,
      402,
      404,
      406,
      408,
      410
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 3,
        "tables": [
          "a"
        ]
      },
      {
        "level": 7,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 63.028,
    "source": "esoteria-exe"
  },
  {
    "songId": 2,
    "intensity": 2,
    "entryIds": [
      412,
      414,
      416,
      418,
      420,
      422,
      424
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 3,
        "tables": [
          "a"
        ]
      },
      {
        "level": 7,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 63.218,
    "source": "esoteria-exe"
  },
  {
    "songId": 3,
    "intensity": 0,
    "entryIds": [
      706,
      426,
      428,
      430,
      432,
      434,
      436
    ],
    "missingEntryIds": [
      706
    ],
    "levels": [
      {
        "level": 0,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 43.461,
    "source": "esoteria-exe"
  },
  {
    "songId": 3,
    "intensity": 1,
    "entryIds": [
      438,
      440,
      442,
      444,
      446,
      448,
      450
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 0,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 56.086,
    "source": "esoteria-exe"
  },
  {
    "songId": 3,
    "intensity": 2,
    "entryIds": [
      452,
      454,
      456,
      458,
      460,
      462,
      464
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 0,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 57.75,
    "source": "esoteria-exe"
  },
  {
    "songId": 4,
    "intensity": 0,
    "entryIds": [
      466,
      468,
      470,
      472,
      474,
      476,
      478
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 5,
        "tables": [
          "a"
        ]
      },
      {
        "level": 8,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 53.842,
    "source": "esoteria-exe"
  },
  {
    "songId": 4,
    "intensity": 1,
    "entryIds": [
      480,
      482,
      484,
      486,
      488,
      490,
      492
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 5,
        "tables": [
          "a"
        ]
      },
      {
        "level": 8,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 59.631,
    "source": "esoteria-exe"
  },
  {
    "songId": 4,
    "intensity": 2,
    "entryIds": [
      494,
      496,
      498,
      500,
      502,
      504,
      506
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 5,
        "tables": [
          "a"
        ]
      },
      {
        "level": 8,
        "tables": [
          "b"
        ]
      }
    ],
    "totalDurationSec": 53.214,
    "source": "esoteria-exe"
  },
  {
    "songId": 5,
    "intensity": 0,
    "entryIds": [
      508,
      510,
      512,
      514,
      516,
      518,
      520
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 1,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 54.981,
    "source": "esoteria-exe"
  },
  {
    "songId": 5,
    "intensity": 1,
    "entryIds": [
      522,
      524,
      526,
      528,
      530,
      532,
      534,
      540,
      542,
      544
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 1,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 69.471,
    "source": "esoteria-exe"
  },
  {
    "songId": 5,
    "intensity": 2,
    "entryIds": [
      546,
      548,
      550,
      552,
      554,
      556,
      558
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 1,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 52.439,
    "source": "esoteria-exe"
  },
  {
    "songId": 6,
    "intensity": 0,
    "entryIds": [
      560,
      562,
      564,
      566,
      570,
      572,
      574,
      576,
      578
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 3,
        "tables": [
          "b"
        ]
      },
      {
        "level": 8,
        "tables": [
          "a"
        ]
      }
    ],
    "totalDurationSec": 73.246,
    "source": "esoteria-exe"
  },
  {
    "songId": 6,
    "intensity": 1,
    "entryIds": [
      580,
      582,
      584,
      586,
      590,
      592,
      596,
      594,
      598
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 3,
        "tables": [
          "b"
        ]
      },
      {
        "level": 8,
        "tables": [
          "a"
        ]
      }
    ],
    "totalDurationSec": 66.17,
    "source": "esoteria-exe"
  },
  {
    "songId": 6,
    "intensity": 2,
    "entryIds": [
      600,
      602,
      604,
      606,
      608,
      610,
      612,
      614
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 3,
        "tables": [
          "b"
        ]
      },
      {
        "level": 8,
        "tables": [
          "a"
        ]
      }
    ],
    "totalDurationSec": 62.99,
    "source": "esoteria-exe"
  },
  {
    "songId": 7,
    "intensity": 0,
    "entryIds": [
      616,
      618,
      620,
      622,
      624,
      626,
      628
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 6,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 75.447,
    "source": "esoteria-exe"
  },
  {
    "songId": 7,
    "intensity": 1,
    "entryIds": [
      630,
      632,
      634,
      636,
      638,
      640,
      642
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 6,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 73.929,
    "source": "esoteria-exe"
  },
  {
    "songId": 7,
    "intensity": 2,
    "entryIds": [
      644,
      646,
      648,
      650,
      652,
      654,
      656
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 6,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 63.5,
    "source": "esoteria-exe"
  },
  {
    "songId": 8,
    "intensity": 0,
    "entryIds": [
      658,
      660,
      662,
      664,
      666,
      668,
      670
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 9,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 133.745,
    "source": "esoteria-exe"
  },
  {
    "songId": 8,
    "intensity": 1,
    "entryIds": [
      672,
      674,
      676,
      678,
      680,
      682,
      684
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 9,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 78.304,
    "source": "esoteria-exe"
  },
  {
    "songId": 8,
    "intensity": 2,
    "entryIds": [
      686,
      688,
      690,
      692,
      694,
      696,
      698
    ],
    "missingEntryIds": [],
    "levels": [
      {
        "level": 9,
        "tables": [
          "a",
          "b"
        ]
      }
    ],
    "totalDurationSec": 72.368,
    "source": "esoteria-exe"
  }
]
